/*
 * ISP / FTTH package COGS engine per wilayah.
 */
let _iid = 0;
const nid = (p) => `${p}-${Date.now().toString(36)}-${(_iid++).toString(36)}`;

export const CAPEX_CATEGORIES = ["Server & Infrastruktur", "Perangkat Jaringan", "Kabel & Pasif", "Perizinan", "Instalasi", "Kelistrikan", "Lainnya"];
export const OPEX_CATEGORIES = ["Sewa", "Utilitas", "SDM", "Operasional", "Pemasaran", "Lainnya"];

export const capexTemplate = () => [
  { id: nid("cx"), category: "Server & Infrastruktur", name: "Server billing / RADIUS / monitoring", qty: 1, unitPrice: 25000000, lifeMonths: 60 },
  { id: nid("cx"), category: "Perangkat Jaringan", name: "OLT GPON 8/16 port", qty: 1, unitPrice: 60000000, lifeMonths: 60 },
  { id: nid("cx"), category: "Perangkat Jaringan", name: "Router core (BGP)", qty: 1, unitPrice: 30000000, lifeMonths: 60 },
  { id: nid("cx"), category: "Perangkat Jaringan", name: "Switch distribusi", qty: 2, unitPrice: 8000000, lifeMonths: 60 },
  { id: nid("cx"), category: "Kabel & Pasif", name: "Kabel FO backbone & distribusi (per km)", qty: 10, unitPrice: 9000000, lifeMonths: 120 },
  { id: nid("cx"), category: "Kabel & Pasif", name: "ODC", qty: 2, unitPrice: 6000000, lifeMonths: 120 },
  { id: nid("cx"), category: "Kabel & Pasif", name: "ODP + splitter", qty: 60, unitPrice: 1500000, lifeMonths: 120 },
  { id: nid("cx"), category: "Kabel & Pasif", name: "Tiang", qty: 120, unitPrice: 1100000, lifeMonths: 120 },
  { id: nid("cx"), category: "Perizinan", name: "Izin penyelenggaraan & legal", qty: 1, unitPrice: 50000000, lifeMonths: 60 },
  { id: nid("cx"), category: "Perizinan", name: "Izin lokasi / pemda / galian", qty: 1, unitPrice: 15000000, lifeMonths: 60 },
  { id: nid("cx"), category: "Instalasi", name: "Instalasi backbone, splicing & OTDR", qty: 1, unitPrice: 30000000, lifeMonths: 60 },
  { id: nid("cx"), category: "Kelistrikan", name: "UPS / baterai / genset POP", qty: 1, unitPrice: 20000000, lifeMonths: 60 },
];

export const opexTemplate = () => [
  { id: nid("ox"), category: "Sewa", name: "Sewa kantor / POP", monthly: 5000000 },
  { id: nid("ox"), category: "Utilitas", name: "Listrik POP & kantor", monthly: 2500000 },
  { id: nid("ox"), category: "Sewa", name: "Sewa DC / colocation", monthly: 3000000 },
  { id: nid("ox"), category: "SDM", name: "Gaji teknisi & NOC", monthly: 16000000 },
  { id: nid("ox"), category: "SDM", name: "Gaji CS, admin & sales", monthly: 8000000 },
  { id: nid("ox"), category: "Operasional", name: "Maintenance jaringan & spare part", monthly: 2500000 },
  { id: nid("ox"), category: "Sewa", name: "Sewa tiang / IRU / duct", monthly: 1500000 },
  { id: nid("ox"), category: "Operasional", name: "Software billing, lisensi & tools", monthly: 1000000 },
  { id: nid("ox"), category: "Pemasaran", name: "Marketing & promosi", monthly: 2000000 },
];

export const packagesTemplate = () => [
  { id: nid("pk"), name: "Home 20 Mbps", speedMbps: 20, price: 199000, subscribers: 120, mixPct: 40, contention: 8 },
  { id: nid("pk"), name: "Home 30 Mbps", speedMbps: 30, price: 249000, subscribers: 90, mixPct: 30, contention: 8 },
  { id: nid("pk"), name: "Home 50 Mbps", speedMbps: 50, price: 349000, subscribers: 60, mixPct: 20, contention: 8 },
  { id: nid("pk"), name: "Home 100 Mbps", speedMbps: 100, price: 499000, subscribers: 30, mixPct: 10, contention: 6 },
];

export const newCapex = () => ({ id: nid("cx"), category: "Lainnya", name: "Item baru", qty: 1, unitPrice: 0, lifeMonths: 60 });
export const newOpex = () => ({ id: nid("ox"), category: "Lainnya", name: "Biaya baru", monthly: 0 });
export const newIspPackage = () => ({ id: nid("pk"), name: "Paket baru", speedMbps: 10, price: 150000, subscribers: 0, mixPct: 0, contention: 8 });

export const ISP_DEFAULT = () => ({
  tab: "input",
  region: { name: "Wilayah Baru", status: "new", city: "", province: "", homesPassed: 1500, notes: "" },
  capex: capexTemplate(),
  opex: opexTemplate(),
  hqAllocation: 0,
  bandwidth: { pricePerMbps: 12000, minCommitMbps: 300 },
  subscriber: { cpeCost: 350000, installCost: 450000, installFee: 250000, amortMonths: 24, variablePerSub: 15000 },
  fees: { bhpPct: 0.5, usoPct: 1.25, otherPct: 0 },
  allocation: "by_speed",
  packages: packagesTemplate(),
  projection: { targetSubscribers: 300, rampMonths: 18, horizonMonths: 36, churnPct: 1 },
});

const num = (x) => (Number.isFinite(+x) ? +x : 0);

export function computeIsp(st) {
  const capexTotal = st.capex.reduce((a, c) => a + num(c.qty) * num(c.unitPrice), 0);
  const capexMonthly = st.capex.reduce((a, c) => a + (num(c.qty) * num(c.unitPrice)) / Math.max(1, num(c.lifeMonths)), 0);
  const opexMonthly = st.opex.reduce((a, c) => a + num(c.monthly), 0) + num(st.hqAllocation);
  const fixedMonthly = capexMonthly + opexMonthly;
  const isNew = st.region.status === "new";
  const mixSum = st.packages.reduce((a, p) => a + num(p.mixPct), 0) || 1;
  const target = num(st.projection.targetSubscribers);

  const pk = st.packages.map((p) => ({
    ...p,
    subs: isNew ? Math.round((target * num(p.mixPct)) / mixSum) : num(p.subscribers),
  }));
  const totalSubs = pk.reduce((a, p) => a + p.subs, 0);
  const totalMbpsSold = pk.reduce((a, p) => a + p.subs * num(p.speedMbps), 0);
  const requiredMbps = pk.reduce((a, p) => a + (p.subs * num(p.speedMbps)) / Math.max(1, num(p.contention)), 0);
  const billedMbps = Math.max(requiredMbps, num(st.bandwidth.minCommitMbps));
  const bwPrice = num(st.bandwidth.pricePerMbps);
  const bandwidthCost = billedMbps * bwPrice;
  const bwScale = requiredMbps > 0 ? billedMbps / requiredMbps : 1;
  const sub = st.subscriber;
  const cpePerSub = Math.max(0, num(sub.cpeCost) + num(sub.installCost) - num(sub.installFee)) / Math.max(1, num(sub.amortMonths));
  const varPerSub = num(sub.variablePerSub);
  const feePct = (num(st.fees.bhpPct) + num(st.fees.usoPct) + num(st.fees.otherPct)) / 100;

  const rows = pk.map((p) => {
    const speed = num(p.speedMbps);
    const fixedShare =
      totalSubs > 0
        ? st.allocation === "per_subscriber"
          ? fixedMonthly / totalSubs
          : totalMbpsSold > 0
          ? (fixedMonthly * speed) / totalMbpsSold
          : 0
        : 0;
    const bw = (speed / Math.max(1, num(p.contention))) * bwPrice * (totalSubs > 0 ? bwScale : 1);
    const fee = num(p.price) * feePct;
    const cogs = fixedShare + bw + cpePerSub + varPerSub + fee;
    const margin = num(p.price) - cogs;
    return {
      ...p,
      fixedShare,
      bw,
      cpe: cpePerSub,
      variable: varPerSub,
      fee,
      cogs,
      margin,
      marginPct: num(p.price) > 0 ? (margin / num(p.price)) * 100 : 0,
      cogsPerMbps: speed > 0 ? cogs / speed : 0,
      revenue: p.subs * num(p.price),
      totalCogs: p.subs * cogs,
    };
  });

  const revenue = rows.reduce((a, r) => a + r.revenue, 0);
  const variableTotal = totalSubs * (cpePerSub + varPerSub) + revenue * feePct;
  const totalCost = fixedMonthly + bandwidthCost + variableTotal;
  const grossProfit = revenue - totalCost;
  const avgPrice = totalSubs ? revenue / totalSubs : 0;
  const avgVar = totalSubs ? (bandwidthCost + variableTotal) / totalSubs : 0;
  const contribution = avgPrice - avgVar;
  const breakEvenSubs = contribution > 0 ? Math.ceil(fixedMonthly / contribution) : null;
  const ebitda = revenue - opexMonthly - bandwidthCost - totalSubs * varPerSub - revenue * feePct;
  const paybackMonths = ebitda > 0 ? capexTotal / ebitda : null;

  const capexByCat = {};
  st.capex.forEach((c) => {
    capexByCat[c.category] = (capexByCat[c.category] || 0) + (num(c.qty) * num(c.unitPrice)) / Math.max(1, num(c.lifeMonths));
  });
  const opexByCat = {};
  st.opex.forEach((c) => {
    opexByCat[c.category] = (opexByCat[c.category] || 0) + num(c.monthly);
  });
  const composition = [
    { name: "Depresiasi CAPEX", value: capexMonthly },
    { name: "OPEX tetap", value: opexMonthly },
    { name: "Bandwidth upstream", value: bandwidthCost },
    { name: "CPE & instalasi (amortisasi)", value: totalSubs * cpePerSub },
    { name: "Variabel per pelanggan", value: totalSubs * varPerSub },
    { name: "BHP, USO & fee", value: revenue * feePct },
  ].filter((x) => x.value > 0);

  const projection = computeProjection(st, { capexTotal, capexMonthly, opexMonthly, cpePerSub, varPerSub, feePct, bwPrice, pk, totalSubs, mixSum });

  return {
    capexTotal,
    capexMonthly,
    opexMonthly,
    fixedMonthly,
    rows,
    totalSubs,
    totalMbpsSold,
    requiredMbps,
    billedMbps,
    bandwidthCost,
    cpePerSub,
    varPerSub,
    feePct: feePct * 100,
    revenue,
    totalCost,
    grossProfit,
    marginPct: revenue > 0 ? (grossProfit / revenue) * 100 : 0,
    avgPrice,
    breakEvenSubs,
    ebitda,
    paybackMonths,
    cogsPerMbps: totalMbpsSold > 0 ? totalCost / totalMbpsSold : 0,
    costPerSub: totalSubs > 0 ? totalCost / totalSubs : 0,
    capexByCat,
    opexByCat,
    composition,
    projection,
    takeRate: num(st.region.homesPassed) > 0 ? (totalSubs / num(st.region.homesPassed)) * 100 : null,
  };
}

function computeProjection(st, c) {
  const pr = st.projection;
  const H = Math.max(1, Math.min(120, num(pr.horizonMonths)));
  const ramp = Math.max(1, num(pr.rampMonths));
  const isNew = st.region.status === "new";
  const target = isNew ? num(pr.targetSubscribers) : c.totalSubs;
  const startSubs = isNew ? 0 : c.totalSubs;
  const churn = num(pr.churnPct) / 100;
  // mix-weighted avg price & mbps/contention
  const weights = c.pk.map((p) => (isNew ? num(p.mixPct) / c.mixSum : c.totalSubs ? p.subs / c.totalSubs : 0));
  const avgPrice = c.pk.reduce((a, p, i) => a + weights[i] * num(p.price), 0);
  const avgMbpsNeed = c.pk.reduce((a, p, i) => a + (weights[i] * num(p.speedMbps)) / Math.max(1, num(p.contention)), 0);
  const sub = st.subscriber;
  const acqCost = num(sub.cpeCost) + num(sub.installCost) - num(sub.installFee);
  let prevSubs = startSubs;
  let cumulative = isNew ? -c.capexTotal : 0;
  const out = [];
  let breakEvenMonth = null;
  let paybackMonth = null;
  for (let m = 1; m <= H; m++) {
    const subs = isNew ? Math.round(target * Math.min(1, m / ramp)) : target;
    const grossAdds = Math.max(0, subs - prevSubs) + Math.round(prevSubs * churn);
    const revenue = subs * avgPrice;
    const bw = Math.max(subs * avgMbpsNeed, num(st.bandwidth.minCommitMbps)) * c.bwPrice;
    const variable = subs * c.varPerSub + revenue * c.feePct;
    const depreciation = c.capexMonthly + subs * c.cpePerSub;
    const cost = c.opexMonthly + bw + variable + depreciation;
    const profit = revenue - cost;
    const cash = revenue - c.opexMonthly - bw - variable - grossAdds * acqCost;
    cumulative += cash;
    if (breakEvenMonth === null && profit >= 0 && subs > 0) breakEvenMonth = m;
    if (paybackMonth === null && cumulative >= 0) paybackMonth = m;
    out.push({ month: m, subs, revenue, cost, profit, cash, cumulative });
    prevSubs = subs;
  }
  return { rows: out, breakEvenMonth, paybackMonth, avgPrice };
}
